export function formatDate(date: string | number): string | null {
    if (!date) return null;

    let thisDate = new Date(date);

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    };

    const dateTimeFormat = new Intl.DateTimeFormat('es', options);

    let dateFormatted = dateTimeFormat.format(thisDate).replace(',', ' a las');

    return dateFormatted;
}
